export const statusConfig = {
  clear: { color: '#4caf50', label: 'Clear', bgColor: 'rgba(76, 175, 80, 0.1)' },
  warning: { color: '#ff9800', label: 'Warning', bgColor: 'rgba(255, 152, 0, 0.1)' },
  emergency: { color: '#f44336', label: 'Emergency', bgColor: 'rgba(244, 67, 54, 0.1)' },
  incomplete: { color: '#9e9e9e', label: 'Incomplete', bgColor: 'rgba(158, 158, 158, 0.1)' },
};

export const headCells = [
  { id: 'status', property: 'status', label: 'Patrol Status', sortable: true, width: '120px' },
  { id: 'startTime', property: 'startTime', label: 'Time', sortable: true, width: '200px' },
  { id: 'guardName', property: 'guardName', label: 'Guard Name', sortable: true, width: '180px' },
  { id: 'comment', property: 'comment', label: 'Comment', sortable: true },
  { id: 'indicators', property: 'indicators', label: 'Patrol', sortable: false, width: '140px' },
];

export const formatDateTime = (dateTimeStr) => {
  const date = new Date(dateTimeStr.replace(' ', 'T'));
  const month = date.toLocaleString('en-US', { month: 'short' });
  const day = date.getDate();
  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const hour12 = hours % 12 || 12;
  return `${month} ${day}, ${hour12}:${minutes} ${ampm}`;
};

export const formatDateTimeLong = (dateTimeStr) => {
  const date = new Date(dateTimeStr.replace(' ', 'T'));
  const month = date.toLocaleString('en-US', { month: 'long' });
  const day = date.getDate();
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const hour12 = hours % 12 || 12;
  return `${month} ${day}, ${year} at ${hour12}:${minutes} ${ampm}`;
};

export const formatDateTimeForInput = (dateTimeStr) => {
  if (!dateTimeStr) return '';
  const date = new Date(dateTimeStr.replace(' ', 'T'));
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const formatDateTimeForApi = (dateTimeStr) => {
  if (!dateTimeStr) return '';
  const date = new Date(dateTimeStr);
  return date.toISOString();
};

export const transformChecklists = (apiChecklists) => {
  const statusMapping = { 1: 'clear', 2: 'warning', 3: 'emergency' };
  return apiChecklists.filter((c) => c.Type !== 'Incident').map((checklist) => {
    const items = checklist.Checkpoints?.map((checkpoint) => {
      const selectedStatus = checkpoint.Status?.find(
        (s) => s.StatusID === checkpoint.SelectedStatusID
      );
      let checkpointStatus = 'incomplete';
      if (checkpoint.ResponseTypeName === 'Status' && selectedStatus?.StatusNumber) {
        checkpointStatus = statusMapping[selectedStatus.StatusNumber] || 'incomplete';
      } else if (checkpoint.Time || checkpoint.DateTime || checkpoint.Comment) {
        checkpointStatus = 'info';
      }

      return {
        id: checkpoint.CheckpointID,
        checkpoint: checkpoint.Name,
        status: checkpointStatus,
        comment: checkpoint.Comment || '',
        time: checkpoint.Time || '',
        dateTime: checkpoint.DateTime,
        statusOptions: checkpoint.Status || [],
        selectedStatusId: checkpoint.SelectedStatusID,
      };
    }) || [];

    return {
      id: checklist.ChecklistID,
      name: checklist.Name,
      status: 'clear',
      items,
    };
  });
};

export const getFileType = (fileOrName) => {
  if (typeof fileOrName === 'object' && fileOrName !== null) {
    if (fileOrName.contentType) {
      const contentType = fileOrName.contentType.toLowerCase();
      if (contentType.startsWith('image/')) return 'image';
      if (contentType.startsWith('video/')) return 'video';
    }
    if (fileOrName.type === 'dds') return 'video';
    const fileName = fileOrName.name || '';
    const ext = fileName.split('.').pop()?.toLowerCase();
    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
    const videoExts = ['mp4', 'mov', 'avi', 'mkv', 'webm', 'wmv'];
    if (imageExts.includes(ext)) return 'image';
    if (videoExts.includes(ext)) return 'video';
    return 'image';
  }
  if (!fileOrName) return 'unknown';
  const ext = fileOrName.split('.').pop()?.toLowerCase();
  const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
  const videoExts = ['mp4', 'mov', 'avi', 'mkv', 'webm', 'wmv'];
  if (imageExts.includes(ext)) return 'image';
  if (videoExts.includes(ext)) return 'video';
  return 'image';
};

export const getFilePreviewUrl = (file) => {
  if (file.type === 'dds') {
    return `/api2.0/CANDDS/Preview/${file.id}`;
  }
  return `/api/fileuploadservice/Preview?FileId=${file.id}`;
};

export const getFileDownloadUrl = (file) => {
  if (file.type === 'dds') {
    return `/api2.0/CANDDS/Preview/${file.id}`;
  }
  return `/api/fileuploadservice/Download?FileId=${file.id}`;
};
